module.exports = __webpack_public_path__ + "static/media/image3-2.a2e66d09.jpg";